module.exports = __webpack_public_path__ + "static/q7_x-5a4daa76cfd5e1b36bf5f7096017255e.png";